import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useReviewListingMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ listingId: e, ...t }) => r.reviewListing(e, t),
		onSuccess: (t, { listingId: n }) => {
			i.invalidateQueries({ queryKey: e.listingModeration() }), i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useReviewListingMutation };
